"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddedLayoutSizeSelector = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var AddedLayoutSizeSelector_css_1 = require("./AddedLayoutSizeSelector.css");
var classnames_1 = __importDefault(require("classnames"));
var AddedLayoutSizeSelector = function (_a) {
    var initialiseWithColumns = _a.initialiseWithColumns, selected = _a.selected;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: (0, classnames_1.default)((0, AddedLayoutSizeSelector_css_1.LayoutSizeSelector)({ selected: selected })), gap: "m", justify: "center", align: "center" },
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "5" }, "Choose how many columns to start with"),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceEvenly", align: "center", gap: "m" },
            react_1.default.createElement(kaleidoscope_1.Button, { "data-interactive-zone": true, onClick: function () { return initialiseWithColumns(2); }, type: kaleidoscope_1.ButtonType.Secondary },
                react_1.default.createElement(icons_1.LayoutTwoColumns, null),
                " 2 columns"),
            react_1.default.createElement(kaleidoscope_1.Button, { "data-interactive-zone": true, onClick: function () { return initialiseWithColumns(3); }, type: kaleidoscope_1.ButtonType.Secondary },
                react_1.default.createElement(icons_1.LayoutThreeColumns, null),
                " 3 columns"),
            react_1.default.createElement(kaleidoscope_1.Button, { "data-interactive-zone": true, onClick: function () { return initialiseWithColumns(4); }, type: kaleidoscope_1.ButtonType.Secondary },
                react_1.default.createElement(icons_1.LayoutFourColumns, null),
                " 4 columns"))));
};
exports.AddedLayoutSizeSelector = AddedLayoutSizeSelector;
